
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/dice",
      function () {
        return require("private-next-pages/play/dice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/dice"])
      });
    }
  